import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import auditReducer from './audit/auditSlice';
import cardsReducer from './cards/cardsSlice';
import clientConfigurationReducer from './clientConfiguration/clientConfigurationSlice';
import commentsReducer from './comments/commentsSlice';
import customersReducer from './customers/customersSlice';
import destPointReducer from './destPoint/destPointSlice';
import driversReducer from './drivers/driversSlice';
import headerReducer from './header/headerSlice';
import historyReducer from './history/historySlice';
import identityReducer from './identity/identitySlice';
import inventorizationReducer from './inventorization/inventorizationSlice';
import iotReducer from './iot/iotSlice';
import usersReducer from './users/usersSlice';
import accessGroupsReducer from './accessGroups/accessGroupsSlice';
import ivazReducer from './ivaz/ivazSlice';
import licensesReducer from './licenses/licensesSlice';
import ordersReducer from './orders/ordersSlice';
import productsReducer from './products/productsSlice';
import reportsReducer from './reports/reportsSlice';
import resultsReducer from './results/resultsSlice';
import rootReducer from './rootReducer';
import rootSaga from './rootSaga';
import settingsReducer from './settings/settingsSlice';
import spyReducer from './spy/spySlice';
import toastReducer from './toast/toastSlice';
import vehiclesReducer from './vehicles/vehiclesSlice';
import warehouseReducer from './warehouse/warehouseSlice';
import weightingsReducer from './weightings/weightingsSlice';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
 reducer: {
  results: resultsReducer.reducer,
  identity: identityReducer.reducer,
  users: usersReducer.reducer,
  accessGroups: accessGroupsReducer.reducer,
  toast: toastReducer,
  clientConfiguration: clientConfigurationReducer,
  comments: commentsReducer,
  reports: reportsReducer,
  ivaz: ivazReducer,
  history: historyReducer,
  header: headerReducer,
  customers: customersReducer.reducer,
  orders: ordersReducer.reducer,
  vehicles: vehiclesReducer.reducer,
  weightings: weightingsReducer.reducer,
  drivers: driversReducer.reducer,
  products: productsReducer.reducer,
  spy: spyReducer.reducer,
  destPoint: destPointReducer.reducer,
  cards: cardsReducer.reducer,
  settings: settingsReducer.reducer,
  licenses: licensesReducer.reducer,
  audit: auditReducer.reducer,
  warehouse: warehouseReducer.reducer,
  inventorization: inventorizationReducer.reducer,
  IoT: iotReducer.reducer,
 },
 middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof rootReducer>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;

